import React from 'react'
import { Box, Typography, Divider, SxProps, Theme } from '@mui/material'

interface SectionHeaderProps {
  title: React.ReactNode
  sx?: SxProps<Theme>
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '50px 0px',
        ...sx
      }}
    >
      <Divider
        sx={{
          width: '3%',
          borderColor: 'secondary.main',
          marginRight: '20px'
        }}
      />
      <Box sx={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
        <Typography variant='h1'>{title}</Typography>
      </Box>
      <Divider
        sx={{
          width: '3%',
          borderColor: 'secondary.main',
          marginLeft: '20px'
        }}
      />
    </Box>
  )
}

export default SectionHeader
